import { ensureArray } from "library/ensure-array/index.mjs"
import { getContext } from "library/get-context.mjs"
import { raise } from "library/local-events/index.mjs"
import { resolveAsFunction } from "library/resolve-as-function.mjs"
const NOT_AUTHORIZED = "Not authorized"
function withPermissions(permission, fn) {
    return checkPermissions(permission, fn, true)
}
function withSomePermissions(permission, fn) {
    return checkPermissions(permission, fn, false)
}
function checkPermissions(permission, fn, and) {
    if (typeof fn === "object") {
        return Object.fromEntries(
            Object.entries(fn).map(([name, value]) => [name, checkPermissions(permission, value, and)])
        )
    }
    return async (...params) => {
        validatePermission(permission, and)
        return fn(...params)
    }
}
function isAdmin() {
    const [{ demands }] = raise("GetDemands", {
        demands: [],
    })
    const fallbackDemands = ensureArray(getContext()?.demands)
    return [...ensureArray(demands), ...fallbackDemands].some((demand) => demand?.includes("admin"))
}
function validatePermission(permission, and = true) {
    if (!checkPermission(permission, and)) {
        throw new Error(NOT_AUTHORIZED)
    }
}
function isFeatureEnabled(feature) {
    return checkPermission(`$feature-${feature}`)
}
function checkPermission(permission, and = true, extraDemands) {
    const [{ demands }] = raise("GetDemands", {
        demands: [],
    })
    const requiredDemands = ensureArray(permission)
        .map((item) => item.trim())
        .filter(Boolean)
    const userDemands = [...ensureArray(demands), ...ensureArray(extraDemands), ...ensureArray(getContext()?.demands)]
    return recurseProcessDemands(requiredDemands, and, userDemands.flat(Infinity))
}
function recurseProcessDemands(demands, and, userDemands) {
    if (Array.isArray(demands)) {
        if (!demands.length) return true
        if (and) {
            return demands.every((demand) => recurseProcessDemands(demand, !and, userDemands))
        }
        return demands.some((demand) => recurseProcessDemands(demand, !and, userDemands))
    }
    return checkIndividualPermission(demands, userDemands)
}
function checkIndividualPermission(demand, demands) {
    demand = resolveAsFunction(demand)()
    if (typeof demand === "boolean") return demand
    if (typeof demand !== "string") return false
    if (!demand) return false
    const requiredDemand = demand.charAt(0) === "$"
    if (requiredDemand) {
        demand = demand.slice(1)
    }
    const invertedDemand = demand.charAt(0) === "!"
    if (invertedDemand) {
        demand = demand.slice(1)
    }
    if (demands.includes("admin") && !requiredDemand) return true
    const hasDemand = demands.includes(demand)
    return invertedDemand ? !hasDemand : hasDemand
}
function hasPermission(permission) {
    return function check() {
        return checkPermission(permission)
    }
}
const authorization = {
    hasPermission,
    validatePermission,
    checkPermission,
    withPermissions,
    withSomePermissions,
    isAdmin,
    isFeatureEnabled,
    NOT_AUTHORIZED,
}
export {
    hasPermission,
    validatePermission,
    checkPermission,
    withPermissions,
    withSomePermissions,
    isAdmin,
    isFeatureEnabled,
    NOT_AUTHORIZED,
}
export default authorization
